<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<h2 class="toc"><span class="bold"><a href="#/xhtml/05_Introduction">Introduction</a></span></h2>
<h2 class="toc"><span class="bold"><a href="#/xhtml/06_Chapter01">The Western Front, summer 1944</a></span></h2>
<h2 class="toc"><span class="bold"><span href="#/xhtml/07_Chapter02" title="Link target outside of Sample">The Pzkpfw IV Units</span></span></h2>
<h2 class="toc"><span class="bold"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample">Camouflage &amp; Markings</span></span></h2>
<h2 class="toc"><span class="bold"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample">Model Showcase</span></span></h2>
<h2 class="toc"><span class="bold"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample">Modelling Products</span></span></h2>
<h2 class="toc"><span class="bold"><span href="#/xhtml/11_Chapter06" title="Link target outside of Sample">Technical Details and Modifications</span></span></h2>
<h2 class="toc"><span class="bold"><span href="#/xhtml/12_Chapter07" title="Link target outside of Sample">The Kriegsstärkenweissung</span></span></h2>
<h2 class="toc"><span class="bold"><span href="#/xhtml/13_Chapter08" title="Link target outside of Sample">Product Contact Details</span></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?bf8b19fe